'use client';
import styled from 'styled-components';

export const LoginFailureContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  max-width: 32rem;
  margin: ${props => props.theme.spacing(10)} auto;
  padding: ${props => props.theme.spacing(0, 6)};
`;

export const LoginFailureMessage = styled.p`
  margin: ${props => props.theme.spacing(0, 0, 6)};
`;
